module.exports = __webpack_public_path__ + "img/1.22826609.png";